import OnboardingFlow from './components/OnboardingFlow';
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { InputOTP, InputOTPGroup, InputOTPSlot } from '@/components/ui/input-otp';
import './onboarding.css';

// Import Firebase configuration and authentication
import { auth, firebaseAuth, firebaseGetMultiFactorResolver } from '../../../js/external-js/config/main_config';
import firebase from 'firebase/compat/app';
import { useNavigate } from 'react-router-dom';

const Onboarding = () => {
  const navigate = useNavigate();

  return (
    <div className="onboarding-container">
      {/* Hidden reCAPTCHA container for MFA */}
      <div id="recaptcha-container" style={{ display: 'none' }}></div>
      {/* Brand header with logo */}
      <div className="brand-header">
        <img src="/assets/img/large_logo_white.svg" alt="de.iterate Logo" className="auth-logo" />
      </div>
      
      {/* Desktop view - centered layout */}
      <div className="desktop-view">
        {/* Content column - centered form */}
        <div className="right-column">
          <div className="onboarding-form-container">
            <div className="onboarding-header">
              <h1>Sign up a new account</h1>
              <p>Enter your email below to sign up to your account</p>
            </div>

            {/* Auth Form */}
            <div className="auth-form">
              <OnboardingFlow variant="default" onComplete={() => navigate('/login')} />
            </div>
            
            {/* Testimonial - moved from left column */}
            <div className="testimonial-centered">
              <blockquote>
                <p>&ldquo;de.cide with clarity, de.liver with confidence, and de.iterate with ease.&rdquo;</p>
                <footer>Harold Quackmore</footer>
              </blockquote>
            </div>

            <p className="terms-text">
              By clicking continue, you agree to our{' '}
              <a href="https://deiterate.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="terms-link">
                Terms of Service
              </a>{' '}
              and{' '}
              <a href="https://deiterate.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="terms-link">
                Privacy Policy
              </a>
              .
            </p>
          </div>
        </div>
      </div>

      {/* Mobile view */}
      <div className="mobile-view">
        <img src="/assets/img/logo.png" alt="de.iterate Logo" className="auth-logo mobile-logo" />
        <div className="mobile-form-container">
          <div className="onboarding-header">
            <h1>Sign up a new account</h1>
            <p>Enter your email below to sign up to your account</p>
          </div>

          {/* Auth Form */}
          <div className="auth-form">
            <OnboardingFlow variant="default" onComplete={() => navigate('/login')} />
          </div>

          <p className="terms-text">
            By clicking continue, you agree to our{' '}
            <a href="https://deiterate.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="terms-link">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="https://deiterate.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="terms-link">
              Privacy Policy
            </a>
            .
          </p>

          <p className="mobile-terms-text">
            By clicking continue, you agree to our{' '}
            <a href="https://deiterate.com/terms-and-conditions/" target="_blank" rel="noopener noreferrer" className="terms-link">
              Terms of Service
            </a>{' '}
            and{' '}
            <a href="https://deiterate.com/privacy-policy/" target="_blank" rel="noopener noreferrer" className="terms-link">
              Privacy Policy
            </a>
            .
          </p>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
